import { AnalyticsPage } from "@/components/analytics/AnalyticsPage";
import { AvatarsTable } from "@/components/analytics/pieces";

export function AnalyticsAvatarsPage() {
  return (
    <AnalyticsPage
      title="Live avatars rollup · Analytics"
      description="Per-avatar rollup of sessions, completion, pass rate and streaming minutes, with interaction mode for every live avatar."
    >
      <div className="page-head">
        <div>
          <h1>Live avatars</h1>
          <p>
            Per-avatar rollup. Each avatar carries its interaction mode. Click any avatar to open its
            session analytics. Scoring columns are blank for non-scorable avatars by design.
          </p>
        </div>
      </div>
      <AvatarsTable />
    </AnalyticsPage>
  );
}